module.exports = __webpack_public_path__ + "assets/img/discernment_clothing_scene1.5b03a5ff.png";